import jexl from 'jexl';
import dayjs, { Dayjs } from 'dayjs';

export const getFieldValue = async (
  fieldName: string,
  previewData: Record<string, unknown>,
) => {
  try {
    let value = `${(await jexl.eval(fieldName, previewData)) ?? ''}`;
    if (value.includes('undefined')) {
      value = value
        .replace(/undefined/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    if (value === 'null') value = '';
    if (value === 'true') value = 'selected';
    // unselected is purposely not set to be consistent with dealer's expectation
    return value;
  } catch (error) {
    return '';
  }
};

// truncate instead of round user input decimals to avoid changing the input value during edit
export const parseCurrencyTruncated = (
  value: string | number | null,
): number => {
  if (!value || Number.isNaN(Number(value))) {
    return 0;
  }
  const [integerStr, decimalStr] = value.toString().split('.');
  if (!decimalStr) {
    return parseInt(integerStr, 10) || 0;
  }
  const twoDecimalsStr = `${decimalStr}00`.slice(0, 2);
  return parseFloat(`${integerStr}.${twoDecimalsStr}`) || 0;
};

export const getUpdatedAt = (field: string, date?: Dayjs): string | null => {
  let format;

  if (field.includes('day@')) {
    format = 'DD';
  }

  if (field.includes('month@')) {
    format = 'MMMM';
  }

  if (field.includes('year@')) {
    format = 'YYYY';
  }

  // handle it normally, this returns digits correspendoing to day/month/year instead of formatting
  if (
    !format &&
    (field.includes('day') || field.includes('month') || field.includes('year'))
  ) {
    return null;
  }

  const updatedAt = (date || dayjs()).format(format || 'MM/DD/YYYY');
  return updatedAt;
};
